<template>
  <div class="page-container">
    <Header />
    
    <div class="sitemap-page">
      <div class="page-header">
        <h1>网站地图</h1>
      </div>

      <div class="container">
        <div class="sitemap-content">
          <div 
            v-for="item in navigationData" 
            :key="item.key" 
            class="sitemap-section"
          >
            <h2>
              <router-link :to="item.path">{{ item.title }}</router-link>
            </h2>
            <div v-if="item.children" class="sitemap-grid">
              <div 
                v-for="subItem in item.children" 
                :key="subItem.key"
                class="sitemap-item"
              >
                <router-link 
                  :to="subItem.path"
                  @click="handleSubMenuClick(subItem.path)"
                >
                  <h3>{{ subItem.title }}</h3>
                  <p v-if="subItem.description">{{ subItem.description }}</p>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script setup>
import { navigationData } from '@/data/navigation'
import Header from '@/layout/header/index.vue'
import Footer from '@/layout/footer/index.vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const handleSubMenuClick = (path) => {
  if (path.includes('#')) {
    const [routePath, hash] = path.split('#')
    if (router.currentRoute.value.path === routePath) {
      const element = document.getElementById(hash)
      if (element) {
        const headerHeight = 80
        const elementTop = element.offsetTop - headerHeight
        window.scrollTo({
          top: elementTop,
          behavior: 'smooth'
        })
      }
    } else {
      router.push(path)
    }
  } else {
    router.push(path)
  }
}
</script>

<style lang="scss" scoped>
.sitemap-page {
  padding: 120px 0 80px;

  .page-header {
    background: linear-gradient(135deg, #2c3e50 0%, #3a506b 100%);
    color: #fff;
    padding: 60px 0;
    text-align: center;
    margin-bottom: 60px;

    h1 {
      font-size: 36px;
      margin: 0;
    }
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .sitemap-content {
    .sitemap-section {
      margin-bottom: 60px;

      h2 {
        font-size: 24px;
        margin-bottom: 30px;
        padding-bottom: 15px;
        border-bottom: 2px solid #eee;

        a {
          color: #333;
          text-decoration: none;
          transition: color 0.3s;

          &:hover {
            color: #2b5dff;
          }
        }
      }

      .sitemap-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        gap: 30px;
      }

      .sitemap-item {
        a {
          display: block;
          padding: 20px;
          background: #f8f9fc;
          border-radius: 8px;
          text-decoration: none;
          transition: all 0.3s;

          &:hover {
            background: #fff;
            transform: translateY(-5px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
          }

          h3 {
            color: #333;
            font-size: 18px;
            margin: 0 0 10px;
          }

          p {
            color: #666;
            font-size: 14px;
            margin: 0;
            line-height: 1.5;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .sitemap-page {
    padding: 100px 0 60px;

    .sitemap-content {
      .sitemap-section {
        .sitemap-grid {
          grid-template-columns: 1fr;
        }
      }
    }
  }
}
</style> 